"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuctionStatusTag = void 0;
var react_1 = __importDefault(require("react"));
var doshx_controls_web_1 = require("doshx_controls_web");
var AuctionStatusTag = function (props) {
    var auctionStatus = props.auctionStatus, size = props.size;
    function determineColors(auctionStatus) {
        switch (auctionStatus) {
            case "Upcoming":
                return {
                    backgroundColor: "bg-secondary",
                    valueColor: "text-white",
                };
            case "Complete":
                return {
                    backgroundColor: "bg-green-500",
                    valueColor: "text-white",
                };
            case "In-Progress":
                return {
                    backgroundColor: "bg-red-500",
                    valueColor: "text-white",
                };
            default:
                return {
                    backgroundColor: "bg-secondary",
                    valueColor: "text-white",
                };
        }
    }
    return react_1.default.createElement(doshx_controls_web_1.BadgeControl, { value: auctionStatus, size: size, colors: determineColors(auctionStatus) });
};
exports.AuctionStatusTag = AuctionStatusTag;
